export default "__VITE_ASSET__CVxBjsfz__"